<div class="modal-dialog start-test-dialog-container">
  <div class="modal-content" cdkTrapFocus goDialogContent [goDialogContentAriaLabelledBy]="dialogTitleId">
    <div class="goreact-modal-header">
      <h4 class="modal-title" translate="modal-recording-instructions_this-is-a-test" [id]="dialogTitleId"></h4>
      <button type="button" class="close-btn" (click)="cancel()" [attr.aria-label]="'common_close' | translate">
        <i class="ficon-app-x"></i>
      </button>
    </div>
    <div class="goreact-modal-body">
      <p>
        <strong translate="modal-recording-instructions_one-attempt"></strong>
      </p>
      @if (data.currentActivity.isCommentOnlySingleAttempt()) {
        <p class="message-content" translate="modal-session-editor_single-attempt-comment-only"></p>
      }
      @if (!data.currentActivity.isCommentOnlySingleAttempt()) {
        <p class="message-content" translate="modal-recording-instructions_upload-not-available"></p>
      }
      @if (data.currentActivity.time_limit > 0) {
        <p
          class="time-limit"
          translate="modal-recording-instructions_time-limit"
          [translateParams]="{ number: data.currentActivity.time_limit }">
        </p>
      }
      @if (!data.currentActivity.time_limit) {
        <p
          class="time-limit"
          translate="modal-recording-instructions_no-time-limit">
        </p>
      }
      @if (showScreenCaptureWarning()) {
        <p
          class="screen-capture-warning"
          translate="modal-recording-instructions_no-screen-capture">
        </p>
      }
    </div>
    <div class="goreact-modal-footer">
      <button
        type="button"
        class="cancel-btn tertiary-btn"
        (click)="cancel()"
        translate="common_not-yet">
      </button>
      <button
        class="confirm-button primary-btn"
        (click)="confirm()"
        data-cy="start-test-button"
        translate="modal-recording-instructions_start-test">
      </button>
    </div>
  </div>
</div>
